import React, { Component } from "react";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";
import img from "../../../Assets/img/Path 2.svg";
import object2 from "../../../Assets/img/OBJECTS (2).svg";
import downArrow from "../../../Assets/img/Group 624.svg";
import start from "../../../Assets/img/Group 2275.svg";
import end from "../../../Assets/img/Group 2250.svg";
import list1 from "../../../Assets/img/problem_solve.svg";
import list2 from "../../../Assets/img/google_searching.svg";
import list3 from "../../../Assets/img/image_reverse.svg";
import list4 from "../../../Assets/img/logical.svg";
import process from "../../../Assets/img/process_section.PNG";
import process_mobile from "../../../Assets/img/process_mobile.png";
import PuzzlerTalk from "../../Components/LandingPage/PuzzlerTalk";
import {
  authenticate,
  make_request,
  calculateTimeLeft,
  inaugural_alert,
} from "../../Utils/Utils";
import "react-circular-progressbar/dist/styles.css";
import Scrollchor from "react-scrollchor";
import autoattend from "../../../Assets/img/auto_attend_logo.png";
import hastag from "../../../Assets/img/logo_hastag.png";
import { pad_num } from "../../Utils/Utils";
import { CircularProgressbar } from "react-circular-progressbar";

class Hero extends Component {
  constructor(props) {
    super(props);
    this.state = {
      starts_in: null,
      start_time: null,
      starting_month: null,
      daysLeft: 0,
      hoursLeft: 0,
      minutesLeft: 0,
      secondsLeft: 0,
    };
  }

  async componentDidMount() {
    if (authenticate()) {
      this.props.history.push("/login");
    } else {
      // let responseJson = await make_request({
      //   path: 'landing_info',
      //   method: 'GET'
      // });
      // let responseJson = {
      //   status: "success",
      //   starts_in: 594097,
      //   start_time: "2020-08-10 19:08",
      //   starting_month: "AUGUST 10, 2020 07:08 PM",
      // };
      let responseJson = {
        status: "success",
        starts_in: 602469,
        start_time: "2020-08-21 12:00",
        starting_month: "August 21, 2020 06:30 AM",
      };
      if (responseJson) {
        if (responseJson.status === "success") {
          if (responseJson.starts_in > 0) {
            this.setState(
              {
                starts_in: responseJson.starts_in,
                start_time: responseJson.start_time,
                starting_month: responseJson.starting_month,
              },
              () => {
                localStorage.setItem(
                  "starts_in",
                  responseJson["starts_in"].toString()
                );
                localStorage.setItem("start_time", responseJson["start_time"]);
                localStorage.setItem(
                  "starting_month",
                  responseJson["starting_month"]
                );
              }
            );
            setInterval(() => {
              let timeArray = calculateTimeLeft(this.state.start_time);
              this.setState({
                daysLeft: timeArray["days"],
                hoursLeft: timeArray["hours"],
                minutesLeft: timeArray["minutes"],
                secondsLeft: timeArray["seconds"],
              });
            }, 1000);
          } else {
            this.setState({
              daysLeft: 0,
              hoursLeft: 0,
              minutesLeft: 0,
              secondsLeft: 0,
            });
          }
        }
      }
    }
  }

  count_down = () => {
    const hour_clock = (interval, timeLeft, maxValue) => {
      return (
        <div className="space_around">
          <span className={interval}>
            <CircularProgressbar
              styles={{
                root: {
                  width: "100%",
                },
                path: {
                  stroke: "#FBBE0D",
                  strokeLinecap: "butt",
                },
                text: {
                  fill: "#FFFFFF",
                  fontSize: "30px",
                },
              }}
              value={timeLeft}
              minValue={0}
              maxValue={maxValue}
              text={pad_num(timeLeft)}
              counterClockwise={true}
            />
          </span>
        </div>
      );
    };

    return (
      <div className="roundrd_timer_box">
        <div className="circle_time1">
          <span className="days">{this.state.daysLeft}</span>
        </div>

        <span className="daytext">Days</span>

        <div className="circle_timer">
          {hour_clock("hours", this.state.hoursLeft, 24)}
          {hour_clock("minutes", this.state.minutesLeft, 60)}
          {hour_clock("seconds", this.state.secondsLeft, 60)}
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        {inaugural_alert(this.state.starting_month)}
        <div className="innerbody">
          {" "}
          <Header />{" "}
        </div>
        <div className="intro py-4 py-lg-9 position-relative text-white">
          <div className="bg-overlay-primary">
            <img
              src={img}
              className="img-fluid img-cover"
              alt="Robust UI Kit"
            />
          </div>
          <div className="intro-content pt-md-11">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-12 col-md-12 col-lg-7 order-md-2 hero-background-img">
                  <div className="d-flex justify-content-center timer_txt_head">
                    <p className="pt-5">
                      <span>
                        {this.state.starts_in > 0
                          ? "First Season Starting in"
                          : "First season is live now"}
                      </span>
                    </p>
                  </div>
                  <div className="row d-flex justify-content-center landing_timers"></div>
                  {this.count_down()}
                  <div className="row d-flex justify-content-center timer_txt_landing pt-3">
                    <p>
                      <span> Hours </span>
                      <span> Mins </span>
                      <span> Secs </span>
                    </p>
                  </div>
                </div>
                <div className="col-12 col-md-12 col-lg-5 text-center">
                  <h2 className="title text-light text-xs-center">
                    <span>Do you like Puzzles? </span> <br />
                    You are at the right place!
                  </h2>
                  <p className="mt-3">
                    Puzzled is an online cryptic riddle, where you get to solve
                    some of the most intelligently crafted levels, providing
                    fodder to the mad genius within you.
                  </p>
                  <div className="text-center text-md-left">
                    <a
                      href="/register"
                      className="btn btn-yellow shadow lift mr-1"
                    >
                      Register &nbsp; <i className="fas fa-play"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="position-absolute center downarrow">
            <p className="btn btn-rounded-circle lift">
              <Scrollchor
                to="#footer"
                animate={{ duration: 1000 }}
                className="nav-link"
              >
                {" "}
                <img src={downArrow} alt="" />{" "}
              </Scrollchor>
            </p>
          </div>
        </div>

        <div className="container-fluid infography position-relative d-xl-none d-lg-none d-md-none d-sm-none d-none">
          <span className="start">
            {" "}
            <img src={start} alt="" />{" "}
          </span>
          <span className="stage1">Begin Playing</span>
          <span className="stage2">Progress by solving each Level</span>
          <span className="stage3">Each Level has various Hints</span>
          <span className="stage4">
            Use the Best of your Problem-solving Tools
          </span>
          <span className="stage5">Race against your competitors to Win</span>
          <h3>PLAYING PUZZLED</h3>
          <span className="end">
            {" "}
            <img src={end} alt="" />{" "}
          </span>
        </div>

        <div className="process_img d-xl-block d-lg-block d-md-block d-sm-none d-none">
          <img src={process} alt="" />
        </div>

        <div className="process_img d-xl-none d-lg-none d-md-none d-sm-block d-block">
          <img src={process_mobile} alt="" />
        </div>

        <div className="container how-to pt-5 pb-5">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-12 col-12">
              <h3 className="mb-4">How to play</h3>
              <h4 className="mb-0">Attention to Detail</h4>
              <p>
                Clearly observe and study every element in each level.
                Everything is there for a reason.
              </p>

              <h4 className="mb-0 pt-3">Google is your Best Friend</h4>
              <p>
                Google is always a good idea. Make sure you look up any clues,
                as this will often help you get closer to the answer.
              </p>
              <h4 className="mb-0 pt-3">Crack the Level</h4>
              <p>
                There is no limit on the number of attempts. So keep guessing
                and keep solving.
              </p>

              <h4 className="mb-0 pt-3">Hall of Fame</h4>
              <p>Complete all levels and get on to our coveted Hall of Fame.</p>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-12">
              <img src={object2} className="left-object" alt="" />
            </div>
          </div>
        </div>

        <div className="container-fluid bg-base">
          <div className="container">
            <div className="row">
              <div className="col pl-0 pr-0">
                <div className="card card-body border-0 o-hidden mb-0 text-light signup_now">
                  <div className="position-relative flex-column flex-md-row align-items-center">
                    <div className="h3 text-center mb-md-0">
                      <span>Are you up for the challenge ?</span> Sign up now
                      and start cracking!{" "}
                      <a
                        href="/register"
                        className="btn btn-lg btn-yellow ml-5"
                      >
                        REGISTER
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="skill-Area">
          <div className="container pt-5 pb-5">
            <div className="row justify-content-center text-center mb-6">
              <div className="col-xl-8 col-lg-9">
                <h2 className="display-4 mx-xl-6">SKILLS REQUIRED</h2>
              </div>
            </div>
            <div className="row text-center skills_required">
              <div className="col-md-3 col-lg-3 col-6 mb-4 mb-lg-0">
                <img src={list1} alt="" /> <br />
                <span>
                  {" "}
                  Problem <br /> Solving{" "}
                </span>
              </div>
              <div className="col-md-3 col-lg-3 col-6 mb-4 mb-lg-0">
                <img src={list2} alt="" /> <br />
                <span>
                  {" "}
                  Google <br /> Searching{" "}
                </span>
              </div>
              <div className="col-md-3 col-lg-3 col-6 mb-4 mb-lg-0">
                <img src={list3} alt="" /> <br />
                <span>
                  {" "}
                  Image Reverse <br /> Search{" "}
                </span>
              </div>
              <div className="col-md-3 col-lg-3 col-6 mb-4 mb-lg-0">
                <img src={list4} alt="" /> <br />
                <span>
                  {" "}
                  Logical <br /> Reasoning{" "}
                </span>
              </div>
            </div>
          </div>
        </section>
        <div className="section-bottom">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-12 col-12 pt-5">
                <h3>Want to get your brain cells ready?</h3>
                <p>
                  If you want to have a crack at something close to the real
                  game, do play our Warm Up game. It will gear you up for the
                  main event!
                </p>
                <div className="text-left">
                  {" "}
                  <a href="/editions" className="btn btn-yellow">
                    PLAY WARM UP
                  </a>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-powered-by pt-4 pb-4">
          <div className="container">
            <div className="row text-center">
              <h3 className="ml-auto mr-auto">POWERED BY</h3>
            </div>
            <div className="row mt-3">
              <div className="col-lg-6 col-md-12 col-12 pb-4">
                <h4>They make us run this game</h4>
                <p>
                  The generous contributions of our corporate sponsors give us
                  the ability to do so much more. These businesses and
                  organizations find value in our work and support us. If you
                  would like to sponsor, do get in touch.
                </p>

                <div className="text-left sponsor_buttons">
                  <a href="/become-sponsor" className="btn btn-yellow mt-3">
                    {" "}
                    BECOME A SPONSOR{" "}
                  </a>

                  <a
                    href="/private-puzzled"
                    className="btn btn-yellow mt-3 ml-4"
                    style={{ padding: "7PX 28PX" }}
                  >
                    {" "}
                    HOST AN EVENT{" "}
                  </a>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-12 powered_by pb-4">
                <div className="container">
                  <div className="row">
                    <div className="col-4 offset-2">
                      <a
                        href="https://autoattend.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        <img src={autoattend} alt="" />{" "}
                      </a>
                    </div>
                    <div className="col-4">
                      <a
                        href="https://www.hashtagtechnologies.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        <img src={hastag} alt="" />{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <PuzzlerTalk />
        <Footer />
      </div>
    );
  }
}

export default Hero;
